import { useGetActiveMenusByTypeQuery } from "@me-team/host/main/menu/graphql/menu.hooks";
import { useReactiveVar } from "@apollo/client";
import { currentBranchIdVar, currentCompanyIdVar } from "@me-team/host/main/globalVar/state";

export const useActiveMenusByType = () => {
    const currentCompanyId = useReactiveVar(currentCompanyIdVar);
    const currentBranchId = useReactiveVar(currentBranchIdVar);

    const {
        data: activeMenusByTypeData,
        loading: activeMenusByTypeLoading,
        refetch: activeMenusByTypeRefetch,
        error,
    } = useGetActiveMenusByTypeQuery({
        skip: !currentCompanyId || !currentBranchId,
        variables: {
            companyId: Number(currentCompanyId),
            branchId: Number(currentBranchId),
        },
        onError: (error) => {
            console.error(error);
        },
        fetchPolicy: "network-only",
    });

    const branch = activeMenusByTypeData?.user?.company?.branches?.[0];

    const activeMenusType = {
        DINE_IN: branch?.activeDineInMenu,
        DELIVERY: branch?.activeDeliveryMenu,
        PICK_UP: branch?.activePickUpMenu,
    };

    const replaceableMenus = {
        DINE_IN: branch?.replaceableDineInMenus,
        DELIVERY: branch?.replaceableDeliveryMenus,
        PICK_UP: branch?.replaceablePickUpMenus,
    };

    return {
        activeMenusType,
        replaceableMenus,
        activeMenusByTypeLoading,
        activeMenusByTypeRefetch,
        error,
    };
};
